import { ThemeColorsProperties as a } from "./colors.js";
import { buildColorsCSSVariables as k } from "./colors.js";
import { ThemeSpacingsProperties as n, SpacingsCSSVariables as h } from "./spacings.js";
import { BaseSpacing as x, Spacings as v } from "./spacings.js";
import { css as T } from "styled-components";
import { ThemeName as e } from "./types.js";
import { ColorMatchingNames as O, ThemeOption as Q } from "./types.js";
import { LightThemeColorsCSSVariables as c } from "./light.js";
import { LightTheme as M } from "./light.js";
import { DarkNinjaThemeColorsCSSVariables as p } from "./darkNinja.js";
import { LightNinjaThemeColorsCSSVariables as d } from "./lightNinja.js";
import { DarkThemeColorsCSSVariables as N } from "./dark.js";
import { DarkTheme as B } from "./dark.js";
const o = "data-theme", I = {
  colors: a,
  spacings: n
}, r = {
  [e.DARK]: N,
  [e.LIGHT]: c,
  [e.DARK_NINJA]: p,
  [e.LIGHT_NINJA]: d
}, D = `body[${o}='${e.DARK}' i] &`, y = `body[${o}='${e.DARK_NINJA}' i] &`, i = `body:not([${o}]) &`, L = `body[${o}='${e.LIGHT}' i] &, ${i}`, g = `body[${o}='${e.LIGHT_NINJA}' i] &, ${i}`, t = () => typeof window < "u" ? document.body.dataset.theme : e.LIGHT, H = () => t() === e.DARK, R = () => t() === e.LIGHT, _ = (s) => {
  if (typeof window > "u")
    return;
  const m = new MutationObserver(() => s(t()));
  return m.observe(document.body, { attributes: !0 }), m;
}, G = T`
  ${h}
  ${r.LIGHT}

  &[data-theme=${e.DARK}] {
    ${r.DARK}
  }

  &[data-theme=${e.LIGHT_NINJA}] {
    ${r.LIGHT_NINJA}
  }

  &[data-theme=${e.DARK_NINJA}] {
    ${r.DARK_NINJA}
  }
`;
export {
  x as BaseSpacing,
  O as ColorMatchingNames,
  r as ColorsCSSVariables,
  y as DarkNinjaThemeQuery,
  B as DarkTheme,
  D as DarkThemeQuery,
  g as LightNinjaThemeQuery,
  M as LightTheme,
  L as LightThemeQuery,
  G as SetupThemeStyle,
  v as Spacings,
  h as SpacingsCSSVariables,
  o as THEME_BODY_ATTR,
  I as Theme,
  a as ThemeColorsProperties,
  e as ThemeName,
  i as ThemeNotPickedQuery,
  Q as ThemeOption,
  n as ThemeSpacingsProperties,
  k as buildColorsCSSVariables,
  _ as createThemeChangeObserver,
  t as getCurrentTheme,
  H as isDarkTheme,
  R as isLightTheme
};
